<template>
  <div class="noticeDetail">
    <!-- <Back :pageTitle="myPageTit"></Back> -->
     <div class="noticeBox">
       <h2>{{info.title}}</h2>
       <ul class="flexS">
         <li>发布作者：<span>{{info.writer}}</span></li>
         <li>发布时间：<span>{{ info.date, 'true' | moment}}</span></li>
       </ul>
       <div class="noticeInfo" v-html="info.content">
       </div>
     </div>
  </div>
</template>

<script>
import { noticeDetail, messageDetail } from '../../src/api/Api'
// import Back from '../components/Back'
export default {
  name: 'noticeDetail',
  components: {
  },
  data () {
    return {
      myPageTit: '公告详情',
      info: {
        title: '',
        writer: '',
        date: '',
        content: ''
      }
    }
  },
  created () {
    let type = this.$route.query.type
    if (type === 1) {
      this.GetnoticeDetail()
    } else if (type === 2) {
      this.GetmessageDetail()
    }
  },
  methods: {
    GetnoticeDetail () {
      var _this = this
      noticeDetail({
        'id': Number(_this.$route.query.id)
      }).then(res => {
        _this.info.title = res.data.data.title
        _this.info.writer = res.data.data.sys_user_name
        _this.info.date = res.data.data.create_date
        _this.info.content = res.data.data.notice_content
      })
    },
    GetmessageDetail () {
      var _this = this
      messageDetail({
        'id': Number(_this.$route.query.id)
      }).then(res => {
        _this.info.title = res.data.data.title
        _this.info.writer = res.data.data.sys_user_name
        _this.info.date = res.data.data.send_time
        _this.info.content = res.data.data.content
      })
    }
  }
}
</script>
<style scoped>
html{
  background: #fff!important;
}
</style>



// WEBPACK FOOTER //
// src/views/NoticeDetail.vue